import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
export default normalize(function (options) {
  tt.pageScrollTo(options);
}, CONTAINER_NAME.BYTE);